import RiskFormPage from "./risk-form-page.jsx";
import "./style.less";

export default RiskFormPage;
